import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  loader: {
    border: "6px solid #f3f3f3",
    borderTop: "6px solid #3498db",
    borderRadius: "50%",
    width: 60,
    height: 60,
    animation: "$spin 1s linear infinite",
    margin: "0 auto",
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
  container: {
    display: "flex",
    color: "white",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center",
  },
}));

export default function BaseLoading({ title = "Loading..." }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.loader}></div>
      <p>{title}</p>
    </div>
  );
}
